// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3495":"6193eb13","3527":"532ec94a","3756":"d0dbc11a"}[chunkId] + ".chunk.css";
};